<template>
  <div :class="classes">
    <label v-if="label" :class="placeholderClasses">
        {{ label }}
    </label>
    <multiselect
      v-model="selectedValue"
      ref="select"
      :label="showBy"
      :trackBy="trackBy"
      :options="options"
      :searchable="false"
      :show-labels="false"
      :allow-empty="false"
      placeholder=""
      @open="handleSelectOpen"
      @click="handleSelectClick"
    >
      <template #caret>
        <div class="arrow">
          <kp-icon name="chevron_down" />
        </div>
      </template>
    </multiselect>

    <AlertBox :is-show="error && showErrorText" :message="error" />
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'KpSelect',

  components: {
    Multiselect
  },

  props: {
    modelValue: {
      type: [Number, String, null],
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
    trackBy: {
      type: String,
      default: 'id'
    },
    showBy: {
      type: String,
      default: 'name'
    },
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    showErrorText: {
      type: Boolean,
      default: true,
    },
    error: {
      type: String,
      default: null
    },
    allowEmpty: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpening: false
    }
  },
  computed: {
    selectedValue: {
      get() {
        return this.options.find(option => option[this.trackBy] === this.modelValue)
      },
      set(value) {
        if (!value) {
          this.$emit('update:modelValue', null)
          return
        }

        this.$emit('update:modelValue', value[this.trackBy])
      }
    },

    classes() {
      return [
        'select-control',
        this.selectedValue && 'select-control_has-value'
      ]
    },
    placeholderClasses() {
      return [
        'placeholder',
        this.required && 'placeholder_is-required'
      ]
    }
  },
  methods: {
    handleSelectOpen() {
      this.isOpening = true
    },
    handleSelectClick() {
      if (!this.isOpening) {
        this.$refs.select?.deactivate();
      }
      this.isOpening = false
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
.select-control {
  min-height: 56px;
  position: relative;
  margin-bottom: 15px;
  .placeholder {
    display: block;
    position: absolute;
    font-size: 16px;
    z-index: 51;
    top: 29px;
    transform: translateY(-50%);
    left: 16px;
    color: #808183;
    pointer-events: none;
    transition: 0.3s;
    &_is-required {
      &::after {
        content: '';
        position: relative;
        display: inline-block;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        margin-left: 5px;
        bottom: 7px;
        background: #D92121;
      }
    }
  }

  .multiselect {
    height: 56px;

    ::v-deep(.multiselect__tags) {
      height: 100%;
      border-radius: 12px;
      border: 1px solid #dcdde0;
      font-size: 16px;
      padding: 0;
      transition: border 0.3s ease-in-out;
      cursor: pointer;
      .multiselect__single {
        padding: 0;
        margin: 0;
        min-height: initial;
        height: 100%;
        padding: 28px 30px 12px 16px;
        line-height: 16px;
        border-radius: 12px;
        cursor: pointer;
      }
    }
    ::v-deep(.arrow) {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      transition: transform 0.3s;
      z-index: 51;
      pointer-events: none;
      line-height: 0;
    }
    ::v-deep(.multiselect__content-wrapper) {
      margin: 10px 0;
      border: 1px solid #dcdde0;
      border-radius: 12px;

      .multiselect__option {
        color: #000000;

        &:hover {
          background: #f8f6f365;
        }

        &--highlight {
          background: initial;
          color: #000000;
        }

        &--selected {
          background: #f8f6f3;

          &.multiselect__option--highlight {
            background: #f8f6f3;
          }
        }
      }
    }
    &--active {
      ::v-deep(.arrow) {
        transform: translateY(-50%) rotate(180deg);
      }
      ::v-deep(.multiselect__tags) {
        border-color: #9a2b0b;
      }
    }
  }
  &_has-value {
    .placeholder {
      top: 16px;
      font-size: 12px;
    }
  }
}
</style>
